// constants
import { ROW_HEIGHT_PER_DUTY } from '../RosterPlan.consts';

/**
 * Only the counts are read, so the parameter is the shape this needs rather than the whole
 * `EmployeeDutyData`: MUI hands `getRowHeight` a widened `GridValidRowModel`, and a structural type
 * accepts that without a cast.
 */
type EmployeeRowHeightInput = {
  days?: (
    | { duties?: unknown[]; otherCostCentersDuties?: unknown[] }
    | undefined
  )[];
};

/**
 * How tall one employee row has to be: as many duty slots as the busiest day in the period.
 *
 * Duties from other cost centres count too — they render in the same cell — so the maximum is taken
 * over both lists rather than over `duties` alone. An employee with nothing rostered still gets one
 * slot, so the row does not collapse.
 */
export const getEmployeeRowHeight = (employee?: EmployeeRowHeightInput) => {
  const days = employee?.days ?? [];

  const dutyCounts = days.map((day) => day?.duties?.length ?? 0);
  const otherCostCenterCounts = days.map(
    (day) => day?.otherCostCentersDuties?.length ?? 0
  );

  return (
    ROW_HEIGHT_PER_DUTY * Math.max(...dutyCounts, ...otherCostCenterCounts, 1)
  );
};
